import { api } from './api';

export interface DashboardPayment {
    payment_id: string;
    date: string;
    status: string;
    price: number;
}

export interface DashboardSubscription {
    id: number;
    user_id: number;
    plan_name: string;
    price: number;
    status: string;
    payment_status: string;
    payment_reference: string;
    starts_at: string;
    ends_at: string;
    created_at: string;
    updated_at: string;
    cancelled_at: string | null;
}

export interface DashboardData {
    firstname: string;
    lastname: string;
    email: string;
    plan_id?: number | null;
    phone?: string | null;
    address?: string | null;
    city?: string | null;
    postal_code?: string | null;
    country?: string | null;
    payments: DashboardPayment[];
    subscriptions: DashboardSubscription[];
}

export interface DashboardResponse {
    success: boolean;
    message: string;
    data: DashboardData;
}

export interface UpdateProfilePayload {
    firstname: string;
    lastname: string;
    display_name: string;
}

export interface UpdateProfileResponse {
    success: boolean;
    message: string;
    data?: {
        firstname: string;
        lastname: string;
        display_name?: string;
        email?: string;
    };
}

export const getDashboard = (token: string): Promise<DashboardResponse> =>
    api.get<DashboardResponse>('/user/dashboard', {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

export const updateProfile = (
    token: string,
    payload: UpdateProfilePayload
): Promise<UpdateProfileResponse> =>
    api.put<UpdateProfileResponse>('/user/profile', payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
